import { render, staticRenderFns } from "./NAM.vue?vue&type=template&id=9254a39a&scoped=true&"
import script from "./NAM.vue?vue&type=script&lang=js&"
export * from "./NAM.vue?vue&type=script&lang=js&"
import style0 from "./NAM.vue?vue&type=style&index=0&id=9254a39a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9254a39a",
  null
  
)

export default component.exports